import { BlogListPage, BlogListPageVariant, ChatBot, NextPageHead, PageView, VWOExperimentPush } from '@aspendental/shared-components-web';
import type { BlogListPageServerSideProps } from './get-blog-list-page-server-side-props';
import DetermineIndexing from '@src/pages/utils/determine-indexing';
export type BlogListPageTemplateProps = BlogListPageServerSideProps;
export const BlogListPageTemplate = (props: BlogListPageTemplateProps) => {
  const {
    siteURL,
    features,
    featureFlags,
    logo
  } = props.config;
  const {
    url: logoUrl
  } = props.appData?.logo ?? {};
  const {
    pageData,
    preview,
    breadcrumbsData,
    pageReferrer,
    domain
  } = props;
  const path = props.path ?? features.blogs.root;
  const {
    metaTitle,
    metaDescription,
    canonical,
    indexed,
    analyticsContext,
    ogImage
  } = pageData;
  const BlogComponent = (pageData.variant ?? 'default') === 'default' ? BlogListPage : BlogListPageVariant;
  return <>
			<VWOExperimentPush decisions={props.vwoDecisions ?? []} data-sentry-element="VWOExperimentPush" data-sentry-source-file="BlogListPageTemplate.tsx" />
			<PageView analyticsContext={analyticsContext} pageReferrer={pageReferrer} siteSection="Marketing" data-sentry-element="PageView" data-sentry-source-file="BlogListPageTemplate.tsx" />
			<NextPageHead path={path} title={metaTitle} indexed={DetermineIndexing(!!indexed, props.env, preview, featureFlags.doNotIndexWholeSite, domain)} description={metaDescription} canonical={canonical} originUrl={siteURL} breadcrumbTitle={breadcrumbsData.breadcrumbTitle} breadcrumbs={breadcrumbsData.breadcrumbsCollection.items} ogImage={ogImage?.desktopImage?.image?.cdn_url ?? logo.dark} data-sentry-element="NextPageHead" data-sentry-source-file="BlogListPageTemplate.tsx" />
			<BlogComponent {...pageData} preview={preview} currentPage={props.currentPage} data-sentry-element="BlogComponent" data-sentry-source-file="BlogListPageTemplate.tsx" />
			{features.chat.enabled && <ChatBot url={features.chat.chatBotURL} isIconButton={features.chat.isIconButton} logoUrl={logoUrl ?? undefined} featureList={featureFlags.featureList} />}
		</>;
};